export default "__VITE_ASSET__3fddfd9a__"